import { ENTITY_ID } from '../../utils/constant';

export const hideFAQForEntityDetails: string[] = [
  ENTITY_ID.rules,
  ENTITY_ID.datasets,
  ENTITY_ID.workflow,
];
